<template>
  <Header />
  <LoyaltyHeader />
  <slot />
  <Footer />
</template>

<script setup>
  
</script>